import { ChangeDetectorRef, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from "@angular/forms";
import { forEach, includes, split } from "lodash-es";
import { PropertiesPanelComponent } from "@wms/properties-panel";
import { BaseComponent, WmsToggleComponent } from "@wms/components";
import { CommonWidgetDirective } from "@wms/directives";

// TODO: replace with App level root
const $rs = {
  deviceTypes: 'TAB',
  isMobileApplicationType: false
}

@Component({
  selector: 'wms-device-config',
  standalone: true,
  imports: [CommonModule, FormsModule, CommonWidgetDirective, WmsToggleComponent],
  templateUrl: './device-config.component.html',
  styleUrls: ['./device-config.component.less']
})
export class DeviceConfigComponent extends BaseComponent  {
  @Input() widthHeader!: string;
  @Input() tableClass!: string;
  @Input() deviceHeader!: string;
  @Input() deviceSizes: any;
  @Input() showAutoResponsiveToggle: boolean;
  @Output() onChange: EventEmitter<{ model: string }> = new EventEmitter();
  regExp = /xs\-[\d]{1,2}|sm\-[\d]{1,2}|md\-[\d]{1,2}|lg\-[\d]{1,2}/g;
  propPanel!: PropertiesPanelComponent;
  isMobileApplicationType: boolean = $rs.isMobileApplicationType;
  modelValue: any;
  deviceType: string = $rs.deviceTypes;
  autoResponsive: boolean = false;
  private cd = inject(ChangeDetectorRef);

  constructor() {
    super();
    this.propPanel = inject(PropertiesPanelComponent);
    this.isMobileApplicationType = this.projectService.isNativeMobileApplicationType()
    this.deviceType = this.isMobileApplicationType ? 'MOBILE' : this.deviceType
  }

  _model: any = {};

  get model() {
    return this.modelValue;
  }

  @Input() set model(val: any) {
    this.modelValue = val;
    this.watch(this.modelValue);
  }

  watch(nv: any) {
    if (nv === 'auto') {
      this.autoResponsive = true;
    } else {
      this.autoResponsive = false;
      if (isNaN(parseInt(nv, 10))) {
        this.splitIntoDevices(nv);
      } else {
        if (this.isMobileApplicationType) {
          this._model.xs = nv;
        } else {
          this._model.sm = nv;
        }
        this._onChange();
      }
    }
  }

  onAutoResponsiveChange(value: any) {
    this.autoResponsive = value;

    // Reset values in dropdown
    if(!this.autoResponsive) {
      this.splitIntoDevices("xs-1 sm-2 md-3 lg-4");
    }

    // Trigger the updated change
    this._onChange();
    this.cd.detectChanges();
  }

  _onChange() {
    let expr = '';
    if (this.autoResponsive) {
      expr = 'auto';
    } else {
      if (this._model.xs && includes(this.deviceSizes, this._model.xs)) {
        expr += 'xs-' + this._model.xs + ' ';
      }
      if (this._model.sm && includes(this.deviceSizes, this._model.sm)) {
        expr += 'sm-' + this._model.sm + ' ';
      }
      if (this._model.md && includes(this.deviceSizes, this._model.md)) {
        expr += 'md-' + this._model.md + ' ';
      }
      if (this._model.lg && includes(this.deviceSizes, this._model.lg)) {
        expr += 'lg-' + this._model.lg;
      }
    }
    this.onChange.emit({model: expr.trim()});
  };

  splitIntoDevices(model: any,) {
    if (model) {
      forEach(model.match(this.regExp), (match: any) => {
        let keys = split(match, '-'),
          device = keys[0],
          value = keys[1];
        this._model[device] = value
      });
    }
  }
}

